/* Copyright Levelise Ltd 2024 - 2026 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const RouteLoadingFallback = () => (
    <div id="loading-route">
        <FontAwesomeIcon icon={faSpinner} size="2x" spin />
    </div>
);

export default RouteLoadingFallback;
